var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PdfView',{style:(_vm.style),attrs:{"pdfImages":_vm.widget.object.pdf_content.thumbnail_url,"pageDuration":_vm.widget.position.data.pageDuration,"imageMode":_vm.widget.position.data.imageMode,"position":"absolute"}})
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }